import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ClinicDataService } from 'src/app/services/data-service/clinic-data-service';
import { EasyNotificationService, NotifyMessage } from 'src/app/services/easy-notification.service';
import { DateHelper } from 'src/app/shared/helpers/date-helper';
import { delay } from 'src/app/shared/utilities';

@Component({
  selector: 'app-notify-log',
  templateUrl: './notify-log.component.html',
  styleUrls: ['./notify-log.component.css']
})
export class NotifyLogComponent implements OnInit {
  /** 是否顯示開啟log用的icon */
  @Input()
  EnableNotifyLog = false;
  /** 檢視提示錯誤的畫面開關 */
  showLog = false;
  /** ='alert' 時顯示鬧鐘動畫 */
  alert:''|'alert' = '';
  /** Icon tip */
  tip = '沒有新的訊息'
  /** icon圖案 */
  icon:'notifications_none'|'notifications_active' = 'notifications_none';
 
  msgLog:NotifyMessage[] = []
  async isSupportedMode(){
    var mode = (await this.clinicData.getParam('SYS101')).NotifyPosition;
    return ['right','right2left','topest'].includes(mode)
  }
  constructor(private notify:EasyNotificationService,
    private clinicData:ClinicDataService
  ) {
  
    notify.OnUnreadMessage.subscribe(async x=>{
      var l = Object.assign({},x);
      l.content = '['+DateHelper.getTimeString(new Date,':',true)+'] '+l.content;
      this.msgLog = [l,...this.msgLog];
      
      this.updateIcon();
      if(!this.showLog){
        this.alert = 'alert';
      }

    });
  }

  async ngOnInit() {
    var sys101 = await this.clinicData.getParam('SYS101')
    this.EnableNotifyLog = sys101.NotifyLog;
  }
 
  open(){
    if(this.msgLog.length==0){
      this.showLog = false;
      return;
    }
    this.showLog = !this.showLog;
    this.alert='';
  }
  read(ind:number){
    this.msgLog.splice(ind,1);
    this.updateIcon();
    this.tip = '沒有新的訊息';
    if(this.msgLog.length == 0){
      this.open();
    }
  }
  updateIcon(){
    this.icon = this.msgLog.length>0?'notifications_active':'notifications_none';
  }
}
